@if (offers().length > 0) {
  @if (offers().length > 1) {
    <slotcom-wizard-modal
      [wizardModalData]="wizardModalData"
      [showArrows]="true"
      [showDots]="false"
      (currentTab)="tabChanged($event)">
      <div [ngTemplateOutlet]="offerTemplate"></div>
    </slotcom-wizard-modal>
  } @else {
    <div [ngTemplateOutlet]="singleOfferTemplate"></div>
  }
}

<ng-template #singleOfferTemplate>
  <div
    class="offer-modal-background"
    [ngStyle]="{ 'background-image': 'url(' + offers()[0].creativity + ')' }">
    <slotcom-navigation-button
      type="close"
      [topPosition]="-2"
      (click)="closeModal()">
    </slotcom-navigation-button>

    <div [ngTemplateOutlet]="offerTemplate"></div>
  </div>
</ng-template>

<ng-template #offerTemplate>
  <div
    class="offer-modal-body"
    data-testid="slotcom-offer-modal-body">
    @if (!multiplierPrize()) {
      <slotcom-display
        data-testid="slotcom-offer"
        [classes]="['c-display--auto', 'c-display--offer']">
        <div
          displayIcon
          displayIconPos="left"
          theming
          themingGroup="none"
          themingAsset="credits-lineless"
          class="c-display--coin"></div>

        <span>
          {{ offers()[tab()].finalValue | number: '1.0-0' : ('common.culture' | translate) }}
        </span>
      </slotcom-display>
    } @else {
      @for (t of [tab()]; track t) {
        <slotcom-display
          data-testid="slotcom-multiplier-offer"
          [classes]="['c-display--auto', 'c-display--offer', 'c-display--offer--multiplier']">
          <div
            displayIcon
            displayIconPos="doubleLeft"
            theming
            themingGroup="none"
            themingAsset="credits-lineless"
            class="c-display--coin"></div>

          <div
            displayIcon
            displayIconPos="doubleLeft"
            theming
            themingGroup="multiplierprize"
            themingAsset="multiplier"
            class="c-display--multiplier"></div>

          <span
            counto
            [delay]="500"
            [countFrom]="offers()[t].finalValue"
            [countTo]="offers()[t].finalValue * multiplierPrize().properties.multiplierprize"
            (countoChange)="valueMultiplied = $event">
            {{ valueMultiplied | number: '1.0-0' : ('common.culture' | translate) }}
          </span>
        </slotcom-display>
      }
    }

    <div class="offer-price-container">
      @if (
        offersType[tab()] === 'DiscountPercent' ||
        offersType[tab()] === 'NotFundsDiscountPercent' ||
        offersType[tab()] === 'FreeCoinsDiscountPercent' ||
        offersType[tab()] === 'NotFundsFreeCoinsDiscountPercent'
      ) {
        <div>
          <div class="test">
            <div class="offer-price">
              <div class="offer-price-discount">
                <div [innerHTML]="'home.shop.offer.now-only' | translate | uppercase"></div>
                <div
                  class="offer-price-text-now"
                  [innerHTML]="offers()[tab()].finalPrice | formatShopPrice"></div>
              </div>
            </div>
            <div class="offer-price">
              <div class="offer-price-discount">
                <div [innerHTML]="'home.shop.offer.before' | translate | uppercase"></div>
                <div
                  class="offer-price-text-before"
                  [innerHTML]="offers()[tab()].originalPrice | formatShopPrice"></div>
                <div class="offer-price-before-block-line"></div>
              </div>
            </div>
          </div>
        </div>
      }
      @if (
        offersType[tab()] !== 'DiscountPercent' &&
        offersType[tab()] !== 'NotFundsDiscountPercent' &&
        offersType[tab()] !== 'FreeCoinsDiscountPercent' &&
        offersType[tab()] !== 'NotFundsFreeCoinsDiscountPercent'
      ) {
        <div>
          <div class="offer-price">
            <div
              class="offer-price-text-only"
              [innerHTML]="'home.shop.offer.only' | translate"></div>
            <div
              class="offer-price-text-now"
              [innerHTML]="offers()[tab()].finalPrice | formatShopPrice"></div>
          </div>
        </div>
      }

      @if (
        offersType[tab()] === 'FreeCoins' ||
        offersType[tab()] === 'DiscountPercent' ||
        offersType[tab()] === 'FreeCoinsDiscountPercent'
      ) {
        <div class="offer-timer-container">
          <slotcom-animated-timer
            class="offer-timer-display"
            [endDate]="offers()[tab()].expirationDate">
          </slotcom-animated-timer>
        </div>
      }
      <div class="buy-button-container">
        <slotcom-button
          data-testid="slotcom-buy-offer-button"
          class="c-button--pink"
          (click)="purchaseOffer(offers()[tab()])"
          audioType="payment">
          {{ offers()[tab()].claim ? offers()[tab()].claim : ('home.shop.offer.buy' | translate | uppercase) }}
        </slotcom-button>
      </div>
      <div class="offer-discount-content">
        @if (offersType[tab()] === 'DiscountPercent' || offersType[tab()] === 'NotFundsDiscountPercent') {
          <div class="offer-discount-container">
            <div>
              <div
                class="discount-percent"
                [innerHTML]="
                  (offers()[tab()].discountPercent | number: '1.0-0' : ('common.culture' | translate)) + '%'
                "></div>
            </div>
            <div>
              <div
                class="discount-text"
                [innerHTML]="'home.shop.offer.discount' | translate | uppercase"></div>
            </div>
          </div>
        }
        @if (
          offersType[tab()] === 'FreeCoins' ||
          offersType[tab()] === 'FreeCoinsDiscountPercent' ||
          offersType[tab()] === 'NotFundsFreeCoins' ||
          offersType[tab()] === 'NotFundsFreeCoinsDiscountPercent'
        ) {
          <div class="offer-discount-container">
            <div>
              <div
                class="discount-percent"
                [innerHTML]="
                  '+' + (freeCoinsPercentage[tab()] | number: '1.0-0' : ('common.culture' | translate)) + '%'
                "></div>
            </div>
            <div>
              <div
                class="discount-text"
                [innerHTML]="'home.shop.offer.more' | translate | uppercase"></div>
            </div>
          </div>
        }
      </div>

      @if (magicbag()) {
        <div class="offer-magicbag-content">
          <div
            data-testId="slotcom-offer-magicbag-tag"
            theming
            themingGroup="magicbag"
            themingAsset="offers-tag"
            class="offer-magicbag-tag"></div>

          <slotcom-display
            data-testid="slotcom-magicbag-offer"
            [classes]="['c-display--auto', 'c-display--magicbag', 'c-display--magicbag--offer']">
            <div
              displayIcon
              displayIconPos="left"
              theming
              themingGroup="none"
              themingAsset="credits-lineless"
              class="c-display--coin"></div>

            <span>{{
              recurringValue() * magicbag()?.properties?.magicbagmultiplier
                | number: '1.0-0' : ('common.culture' | translate)
            }}</span>
          </slotcom-display>
        </div>
      }
    </div>
  </div>
</ng-template>
